import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Send: FC<Props> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}>
    <path fillRule="evenodd" clipRule="evenodd" d="M5.8946 9.33366L4.16084 4.2237L14.6181 9.33366H5.8946ZM5.8943 10.667L4.16084 15.7761L14.6163 10.667H5.8943ZM17.7684 10.6107L4.20767 17.2372C4.19018 17.2458 4.17232 17.2535 4.15415 17.2605C3.95327 17.3377 3.73399 17.3535 3.52413 17.3058C3.31427 17.2582 3.12331 17.1492 2.97549 16.9928C2.83242 16.8416 2.73392 16.6538 2.69089 16.4501C2.64822 16.2482 2.66174 16.0384 2.72993 15.8436L4.71265 9.99989L2.72992 4.15614C2.66174 3.96138 2.64822 3.75161 2.69089 3.54964C2.73395 3.34582 2.83256 3.15788 2.9758 3.00663C3.12358 2.85041 3.31442 2.74158 3.52413 2.69396C3.73399 2.6463 3.95327 2.66207 4.15415 2.73927C4.17232 2.74626 4.19018 2.75403 4.20767 2.76258L17.7927 9.40092C18.0215 9.51274 18.1666 9.74519 18.1666 9.99989C18.1666 10.0134 18.1662 10.0268 18.1654 10.0402C18.1504 10.2957 17.9914 10.5125 17.7684 10.6107Z" fill="inherit" />
  </svg>
);

export default Send;
